import App from './MetalDeckApp';
import { bootstrapReactApp } from '../shared';

bootstrapReactApp('iMetalDeck', <App />);
